import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';

import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { vsprintf } from 'sprintf-js';
import { AppHelper } from '../../../helpers/AppHelper';

export class VenuesSSCampaign extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.pageKey = 'VenuesSSCampaign'
    this.pageTitle = Helper.getString('venues')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.campaignId = this.props.match.params.id
    this.uploadLocation = this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('campaignsSelfServe'), to: this.baseRoute() + '/ss-campaigns' },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['miscs', 'venues-of-ss-campaign'], queryParams: { campaignId: this.campaignId }},
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Venue: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.deviceCode}</span>
            {current.state === 'ARCHIVED' &&
              <Fragment>
                <br/>
                <span className={css(Styles.spanValue, Styles.line2)}> {'ARCHIVED'}</span>
              </Fragment>
            }
            {!current.installationId &&
              <Fragment>
                <br/>
                <span className={css(Styles.spanValue, Styles.line2)}> {'NOT REGISTERED'}</span>
              </Fragment>
            }
            {current.testing === 'YES' &&
              <Fragment>
                <br/>
                <span className={css(Styles.spanValue, Styles.line2)}> {'TESTING(NOT SSP)'}</span>
              </Fragment>
            }
          </div>
        )
      },
      Info: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>Title: {current.title}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>{(current.info && current.info.address) || '(no address)'}</span>
            {current.latestDeviceFeed &&
              <Fragment>
                <br/>
                <span className={css(Styles.spanValue, Styles.line2)}>
                  {
                    vsprintf('%s | App #%s | Model #%s', [
                      AppHelper.formatActiveTime(Helper.currentTs() - current.latestDeviceFeed.currentTs),
                      current.latestDeviceFeed.versionCode,
                      current.latestDeviceFeed.model
                    ])
                  }
                </span>
              </Fragment>
            }
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.orgId
    }
    this.noTableHead = true
    this.noAdd = true
  }

  onFetchSuccess(results) {
    this.setState({
      items: results[0].items || []
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onActions(current) {
    const actions = []
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
  },
  line2: {
    fontSize: 12
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/advertisers/VenuesSSCampaign.js